import Vuex from 'vuex';
import Vue from 'vue';

import Menus from './store/menu';
import Auth from './store/auth';
import AdminMenu from './store/admin-menu';
import Page from './store/page';
import AdminPage from './store/admin-page';
import Image from './store/image';
import AdminUser from './store/admin-users';
import AdminCategories from './store/admin-categores';
import Error from './store/error';
import Contact from './store/contact';
import AdminProduct from './store/admin-product';
import Products from './store/products';
import Categories from './store/category';
import Product from './store/product';
import Progress from './store/progress';
import Cart from './store/cart';
import Order from './store/order';
import Gallery from './store/gallery';

Vue.use(Vuex);

export default new Vuex.Store({
  // strict: true,

  modules: {
    menu: Menus,
    auth: Auth,
    adminMenu: AdminMenu,
    page: Page,
    adminPage: AdminPage,
    image: Image,
    adminUser: AdminUser,
    adminCategories: AdminCategories,
    error: Error,
    contact: Contact,
    adminProduct: AdminProduct,
    products: Products,
    category: Categories,
    product: Product,
    progress: Progress,
    cart: Cart,
    order: Order,
    gallery: Gallery,
  },
});



// WEBPACK FOOTER //
// ./src/store.js